import type { FunctionComponent } from 'react'
import styled from 'styled-components'
import { StyledH5 } from '../../../../shared/stylesNew'
import Button from '../../../../shared/components/Button/Button'
import CrossRoad from '../../../../shared/assets/icons/crossRoad.svg'
import MapSymbol from '../../../../shared/assets/icons/mapSymbol.svg'

const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 1;
  display: flex;
  background-image: url('/assets/images/map/mapScreenshot.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

const OverlayContent = styled.div`
  padding: 1rem;
  margin: 0 1rem;
  background: var(--light);
  align-self: center;
`

const StyledSpan = styled.span`
  color: var(--blue);
  svg {
    height: 1rem;
    width: 1rem;
    margin-right: 0.25rem;
    margin-bottom: -3px;
    path {
      fill: var(--blue);
    }
  }
`

interface MobileMapOverlayProps {
  onOpenMobileMap: () => void
}
const MobileMapOverlay: FunctionComponent<MobileMapOverlayProps> = ({ onOpenMobileMap }) => {
  return (
    <Overlay>
      <OverlayContent>
        <StyledH5>Kaart bekijken</StyledH5>
        <p>
          Voor de beste gebruikerservaring bieden we op mobiele apparaten de kaart{' '}
          <strong>alleen</strong> in ‘volledig scherm’ modus aan.
        </p>
        <p>
          In de ‘volledig scherm’ modus kunt u met de button{' '}
          <StyledSpan>
            &ldquo;
            <CrossRoad />
            Sluiten&rdquo;
          </StyledSpan>{' '}
          terug naar deze pagina.
        </p>
        <Button onClick={onOpenMobileMap}>
          <MapSymbol />
          Bekijk de kaart
        </Button>
      </OverlayContent>
    </Overlay>
  )
}

export default MobileMapOverlay
